import React from "react";
import "./fileUpload.scss";
import UploadSvg from "../../assets/svgs/upload.svg";
import TextInput from "../TextInput";
import PropTypes from "prop-types";

const readFileFromEvent = (e) => {
  return new Promise((resolve) => {
    const file = e.target.files[0];
    if (file) {
      const fileReader = new FileReader();
      fileReader.readAsText(file);
      fileReader.onloadend = () => {
        resolve({
          fileName: file.name,
          contents: fileReader.result
        })
      };
    }
  });
};

const FileUpload = ({onlyIconButton, disabled, className, label, placeholder, error, value, onChange, textFieldProps, uploadInputProps}) => {

  const readFile = async (e) => {
    const file = await readFileFromEvent(e);
    onChange(file)
    e.target.value = ''
  }
  return <div className={`Suc-upload-file ${className} ${disabled ? 'Suc-disabled' : ''}`}>
    <TextInput
      type="text"
      error={error}
      label={label}
      value={value}
      disabled={true}
      placeholder={placeholder}
      className={'Suc-input-container'}
      {...textFieldProps}
    />
    <div
      className={`Suc-file-wrapper`}>
      <input className={'file-input'} disabled={disabled} type="file" onChange={readFile} {...uploadInputProps}/>
      <UploadSvg className={'Suc-upload-svg'}/>
      {!onlyIconButton && <div className={'Suc-upload-text'}>Upload</div>}
    </div>
  </div>
};

FileUpload.propTypes = {
  /** show button with text 'upload' or only upload icon */
  onlyIconButton: PropTypes.bool,
  /** disable uploading */
  disabled: PropTypes.bool,
  /** placeholder */
  placeholder: PropTypes.string,
  /** custom classname */
  className: PropTypes.string,
  /** custom props to the text field */
  textFieldProps: PropTypes.object,
  /** custom props to the file upload input */
  uploadInputProps: PropTypes.object
}

FileUpload.defaultProps = {
  onlyIconButton: false,
  className: '',
  disabled: false,
  textFieldProps: {},
  uploadInputProps: {},
}

export default FileUpload;
